import { Button, Grid, Paper, TextField } from "@mui/material";
import { useEffect, useMemo, useRef, useState } from "react";
import { useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import {
  gridSizeMdLg4,
  newAsignacionesSchema,
  useTableFilter,
} from "@/shared";
import {
  CustomAutocomplete,
  CustomSearch,
  CustomTextField,
  SampleCheckbox,
  SampleDatePicker,
  SampleTable,
  SingleButton,
  SingleTableBoxScene,
  TabTextLabel,
} from "@/shared/components/ui";
import { useUiStore } from "@/store/ui";
import { yupResolver } from "@hookform/resolvers/yup";
import { Activos, Asignaciones } from "@/shared/interfaces/erp/activos";
import { useCreateAsignaciones, useUpdateAsignaciones, usefetchActivos } from "@/shared/actions/erp";
import { ScrollableDialogProps } from "@/shared/components/ui/Dialogs";
import { MRT_ColumnDef } from "material-react-table";
import DeleteIcon from "@mui/icons-material/Delete";
import { Empleado } from "@/shared/interfaces/erp/empleados";
import { useFetchEmpleados } from "@/shared/actions/erp/empleados";


const returnUrlAsig = "/activos/asignaciones";

export interface SaveAsignacionesProps {
  titlePage: string;
  editAsignaciones?: Asignaciones;
}

type SaveFormData = {
  codigo: string;
  fecha_asignacion: string;
  fecha_devolucion: string;
  observaciones: string;
  estado: boolean;
  empleado: string;
  activo?: string;
};

const SaveAsignaciones: React.FC<SaveAsignacionesProps> = ({
  titlePage,
  editAsignaciones,
}) => {
  const navigate = useNavigate();

  ///* local state
  const [productos, setProductos] = useState<Activos[]>([]);
  const [productoId, setProductoId] = useState<number | string>("");
  const [open, setOpen] = useState(false);

  const setAlert = useUiStore(s => s.setAlert);
  const [shrink, setShrink] = useState(false);



  ///* fetch data
  ///* form
  const form = useForm<SaveFormData>({
    resolver: yupResolver(newAsignacionesSchema),
    defaultValues: {
      estado: false,
    },
  });
  const {
    handleSubmit,
    reset,
    register,
    formState: { errors, isValid },
  } = form;
  ///* mutations
  const createAsignacionesMutation = useCreateAsignaciones({ navigate, returnUrl: returnUrlAsig });
  const updateAsignacionesMutation = useUpdateAsignaciones({ navigate, returnUrl: returnUrlAsig });
  ///* handlers
  const onSave = async () => {
    if (!isValid) return;
    const formData = {
      ...form.getValues(),
      activo: productoId,
    } as any;
    if (!formData.activo) {
      setAlert(true, 'Por favor, selecciona al menos un producto.', 'error');
      return;
    }
    if (editAsignaciones?.id_asignacion_activo) {
      return updateAsignacionesMutation.mutate({
        id: editAsignaciones.id_asignacion_activo,
        data: formData,
      });
    }
    return createAsignacionesMutation.mutate(formData);
  }
  const productAddedRef = useRef(false);

  useEffect(() => {
    if (editAsignaciones?.id_asignacion_activo && !productAddedRef.current) {
      setShrink(true);
      reset({
        ...editAsignaciones,
      });
      agregarProducto(editAsignaciones?.activo_data);
      productAddedRef.current = true;
    }
  }, [editAsignaciones]);
  const today = new Date();
  const formattedDate = today.toISOString().slice(0, 10);;



  const { data: dataUser, isLoading: isLoadingUser } =
    useFetchEmpleados({
      enabled: true,
      params: {
        page_size: 1000,
      }
    });
  const agregarProducto = (producto: Activos) => {
    setProductoId(producto.codigo)
    setProductos(prevProductos => [...prevProductos, producto]);
  };
  const eliminarProducto = (idActivo: string) => {
    setProductos(prevProductos => prevProductos.filter(producto => producto.id_activo !== idActivo));
    setProductoId("");
  };
  const { globalFilter, pagination, searchTerm, onChangeFilter, cleanFilter } =
    useTableFilter();
  const { pageIndex } = pagination;
  const { data: ProductosPagingRes } = usefetchActivos({
    page: pageIndex + 1,
    codigo_barras: searchTerm.toUpperCase(),
  });
  const filteredProductos = useMemo(() => {
    if (!searchTerm) return ProductosPagingRes?.data?.data;

    return ProductosPagingRes?.data?.data.filter((item) =>
      item.codigo?.toLowerCase().includes(searchTerm.toLowerCase())
    );
  }, [ProductosPagingRes, searchTerm]);

  const columnsInsertProducto: MRT_ColumnDef<Activos>[] =
    useMemo<MRT_ColumnDef<Activos>[]>(
      () => [
        {
          accessorKey: "actions",
          header: "Acciones",
          Cell: ({ row }) => {
            return (
              <SingleButton
                newCustomButton
                label="AGREGAR"
                variant="text"
                color="success"
                showIcon={false}
                disabled={productos.length > 0}
                onClick={() => {
                  agregarProducto(row.original);
                }}
              />
            );
          },
        },
        {
          accessorKey: "numero_referencia",
          header: "numero referencia",
        },
        {
          accessorKey: "codigo",
          header: "codigo",
        },
        {
          accessorKey: "nombre",
          header: "nombre",
        },
      ],
      [agregarProducto, productos]
    );
  const columnsProductosDetallePedidosDb2: MRT_ColumnDef<Activos>[] =
    useMemo<MRT_ColumnDef<Activos>[]>(
      () => [
        {
          accessorKey: "remove",
          header: "Eliminar",
          Cell: ({ row }) => {
            return (
              <SingleButton
                newCustomButton
                iconButton
                color="error"
                startIcon={<DeleteIcon />}
                onClick={() => {
                  eliminarProducto(row.original.id_activo!);
                }}
              />
            );
          },
        },
        {
          accessorKey: "numero_referencia",
          header: "numero referencia",
        },
        {
          accessorKey: "codigo",
          header: "codigo",
        },
        {
          accessorKey: "nombre",
          header: "nombre",
        },
      ],
      [eliminarProducto]
    );
  return (

    <SingleTableBoxScene
      title={titlePage}
      /* title="Asignaciones" */
      enableBackBtn={true}
      backPageUrl="/activos/asignaciones"
      visibleReport={false}
      enableCreateOrEditBtn={true}
      textCreateOrEditBtn="Guardar"
      fnCreateOrEdit={handleSubmit(onSave, () => {
        setAlert(true, 'Faltan campos por llenar', 'error');
      })}
    >
      <Grid container spacing={3}>
        <SampleDatePicker
          label="fecha asignacion"
          control={form.control}
          error={errors.fecha_asignacion}
          helperText={errors.fecha_asignacion?.message}
          name="fecha_asignacion"
          textFieldKey="fecha_asignacion"
          size={gridSizeMdLg4}
          defaultValue={formattedDate}
        />
        <CustomTextField
          label="codigo"
          name="codigo"
          control={form.control}
          error={errors.codigo}
          helperText={errors.codigo?.message}
          size={gridSizeMdLg4}
          shrink={shrink}
        />
        <CustomAutocomplete<Empleado>
          label="Empleado"
          name="empleado"
          options={dataUser?.data?.data || []}
          valueKey="razon_social"
          actualValueKey="codigo"
          defaultValue={form.getValues().empleado || ''}
          isLoadingData={isLoadingUser}
          control={form.control}
          error={errors.empleado}
          helperText={errors.empleado?.message}
          size={gridSizeMdLg4}
        />
        <SampleDatePicker
          label="fecha devolución"
          control={form.control}
          error={errors.fecha_devolucion}
          helperText={errors.fecha_devolucion?.message}
          name="fecha_devolucion"
          textFieldKey="fecha_devolucion"
          size={gridSizeMdLg4}
          defaultValue={formattedDate}
        />

        <Grid item {...gridSizeMdLg4}>
          <TextField
            {...register("observaciones", {
              required: "La observacion es obligatoria",
            })}
            id="observacion"
            label="Observación"
            fullWidth
            rows={4}
            multiline
            error={Boolean(errors.observaciones)}
            helperText={errors.observaciones?.message}
          />
        </Grid>

        <Grid item {...gridSizeMdLg4}>
          <SampleCheckbox
            label="Estado"
            name="estado"
            control={form.control}
            defaultValue={!!form.getValues().estado}
            isState
          />
        </Grid>
      </Grid>
      <Grid container spacing={3}>
        <Paper className="paper-producto">
          <Grid
            container
            spacing={1}
            justifyContent={"space-between"}
            alignItems={"center"}
          >
            <Grid item>
              <TabTextLabel
                text={"Activos Seleccionados"}
                mt={0}
                pb={0}
                pl={0}
                pt={0}
              />
            </Grid>
            <Grid item>
              <Button onClick={() => setOpen(true)}>
                Agregar Activo
              </Button>
            </Grid>
            <div className="linea"></div>
            <Grid item xs={12}>
              <SampleTable<Activos>
                columns={columnsProductosDetallePedidosDb2}
                data={productos}
              />
            </Grid>
          </Grid>
        </Paper>
      </Grid>
      <ScrollableDialogProps
        open={open}
        title="Activos"
        cancelTextBtn="Cerrar"
        // actions
        onClose={() => setOpen(false)}
        // content
        minWidth="60%"
        contentNode={
          <>
            <Grid container spacing={3}>
              <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                <Grid container item xs={12} spacing={3}>
                  <Grid item lg={8}>
                    <CustomSearch
                      value={globalFilter}
                      onChange={onChangeFilter}
                      cleanFilter={cleanFilter}
                      text="Buscar por codigo de activo"
                    />
                  </Grid>
                </Grid>
                <SampleTable<any>
                  columns={columnsInsertProducto as any}
                  data={filteredProductos || []}
                />
              </Grid>
            </Grid>
          </>
        }
      />
    </SingleTableBoxScene>

  );
};

export default SaveAsignaciones;
